import { authHeader } from '@/_helpers';
export const adminService = {
    getLastUsers,
    getActive,
    getGmailImports,
    getLinkedinImports,
    getOliverSettings,
    getOliverVariables,
    updateWords,
    updateOliverVariables,
    insertNew,
    getOwarmStats,
    getOwarmList,
    getOwarmListTotal,
    getCampaignStepTemplates,
    getCampaignStepTemplate,
    setCampaignStepTemplate,
    deleteCampaignStepTemplate,
    getCampaignStepTemplateTypes,
    addCampaignStepTemplateTypes,
    getEmailsQueue,
    getEmailSyncList,
    changePaymentStatus
};

const apiUrl = process.env.VUE_APP_ROOT_API;


function getLastUsers() {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({})

    };
    return fetch(`${apiUrl}/admin/lastusers`, requestOptions).then(handleResponse);
}

function getActive() {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({})
    };
    return fetch(`${apiUrl}/admin/activecampaigns`, requestOptions).then(handleResponse);
}

function getEmailsQueue() {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({})
    };
    return fetch(`${apiUrl}/admin/get-emails-queue`, requestOptions).then(handleResponse);
}

function getOliverSettings() {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({})
    };
    return fetch(`${apiUrl}/admin/settings`, requestOptions).then(handleResponse);
}

function updateOliverVariables(words, name) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ words, name })
    };
    return fetch(`${apiUrl}/admin/updateolivervariable`, requestOptions).then(handleResponse);
}


function getOliverVariables(name) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ name })
    };
    return fetch(`${apiUrl}/admin/getvariables`, requestOptions).then(handleResponse);
}

function updateWords(words, id) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ words, id })
    };
    return fetch(`${apiUrl}/admin/updatewords`, requestOptions).then(handleResponse);
}
function insertNew(words, title, type) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ words, title, type })
    };
    return fetch(`${apiUrl}/admin/insertwords`, requestOptions).then(handleResponse);
}

function getGmailImports() {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({})
    };
    return fetch(`${apiUrl}/admin/gmailimports`, requestOptions).then(handleResponse);
}

function getLinkedinImports() {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({})
    };
    return fetch(`${apiUrl}/admin/linkedinimports`, requestOptions).then(handleResponse);
}

function getOwarmStats(model) {
    let searchFilter = getDefault(model)
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ searchFilter })
    };
    return fetch(`${apiUrl}/owarm/stats`, requestOptions).then(handleResponse);
}

function getOwarmList(model) {

    model.total = 0
    let searchFilter = getDefault(model)
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ searchFilter }),
    };
    return fetch(`${apiUrl}/owarm/filtered-list`, requestOptions).then(handleResponse);
}

function getOwarmListTotal(model) {
    model.total = 1
    let searchFilter = getDefault(model)
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ searchFilter }),
    };

    return fetch(`${apiUrl}/owarm/filtered-list`, requestOptions).then(handleResponse);
}

function getCampaignStepTemplates(model) {
    let searchFilter = getDefault(model)
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ searchFilter }),
    };

    return fetch(`${apiUrl}/admin/get-campaign-step-templates`, requestOptions).then(handleResponse);
}

function getCampaignStepTemplate(model) {
    let searchFilter = getDefault(model)
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ searchFilter }),
    };

    return fetch(`${apiUrl}/admin/get-campaign-step-template`, requestOptions).then(handleResponse);
}

function setCampaignStepTemplate(template) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ template }),
    };

    return fetch(`${apiUrl}/admin/campaign-step-template`, requestOptions).then(handleResponse);
}

function deleteCampaignStepTemplate(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader('application/json'),
    };

    return fetch(`${apiUrl}/admin/campaign-step-template/${id}`, requestOptions).then(handleResponse);
}

function getCampaignStepTemplateTypes() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json'),
    };

    return fetch(`${apiUrl}/admin/get-campaing-step-template-types`, requestOptions).then(handleResponse);
}

function addCampaignStepTemplateTypes(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify( data ),
    };

    return fetch(`${apiUrl}/admin/add-campaing-step-template-types`, requestOptions).then(handleResponse);
}


function getEmailSyncList(active) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ active }),
    };

    return fetch(`${apiUrl}/admin/get-email-sync-list`, requestOptions).then(handleResponse);
}

function changePaymentStatus(id, payment_status_id) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ id, payment_status_id }),
    };

    return fetch(`${apiUrl}/payments/change-status`, requestOptions).then(handleResponse);
}

function getDefault(model) {
    let searchFilter = Array()
    searchFilter =
    {
        'currentPage': (model.currentPage !== undefined) ? JSON.stringify(model.currentPage) : undefined,
        'cantPerPage': (model.cantPerPage !== undefined) ? JSON.stringify(model.cantPerPage) : undefined,
        'total': (model.total !== undefined) ? JSON.stringify(model.total) : undefined,
        'client_id': (model.client_id !== undefined) ? JSON.stringify(model.client_id) : undefined,
        'from_owarm_id': (model.from_owarm_id !== undefined) ? JSON.stringify(model.from_owarm_id) : undefined,
        'step': (model.step !== undefined) ? model.step : undefined,
        'campaign_step_template_type_id': (model.campaign_step_template_type_id !== undefined) ? model.campaign_step_template_type_id : undefined,
        'campaign_step_template_part_id': (model.campaign_step_template_part_id !== undefined) ? model.campaign_step_template_part_id : undefined,
        'id': (model.id !== undefined) ? model.id : undefined,
        'parent_id': (model.parent_id !== undefined) ? model.parent_id : undefined,
        'language_id': (model.language_id !== undefined) ? model.language_id : undefined,
        'isPreviewEmail': (model.isPreviewEmail !== undefined) ? model.isPreviewEmail : undefined,
        'tag_id': (model.tag_id !== undefined) ? model.tag_id : undefined,
        'withTags': (model.withTags !== undefined) ? model.withTags : undefined,
    }
    return searchFilter
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = data || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}
